const USER_SESSION_KEY = 'TM_USER_SESSION_KEY'

export default USER_SESSION_KEY
